import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-affiliate-program';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Posh Affiliate Program - Get PAID to use Poshmark</title>
        <meta
          name='description'
          content='Collaborate with Poshmark and get paid for it! Learn how to get in and the pros and cons of the Poshmark Affiliate program!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-affiliate-program' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-affiliate-program' />
        <meta property='og:title' content='The Posh Affiliate Program - Get PAID to use Poshmark' />
        <meta
          property='og:description'
          content='Collaborate with Poshmark and get paid for it! Learn how to get in and the pros and cons of the Poshmark Affiliate program!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-09-25T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-09-25T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
